"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = exports.Context = void 0;
const createDataContext_1 = __importDefault(require("./createDataContext"));
const types_1 = require("@voltmoney/types");
const utility_1 = require("../utility");
const lodash_1 = __importDefault(require("lodash"));
const initialState = {
    isCameraWebOpen: false,
    routeMap: null,
};
const setDataStorePageTypeData = (template = utility_1.EmptyTemplate, datastore = {}) => {
    return {
        layout: Object.assign({}, template === null || template === void 0 ? void 0 : template.layout),
        datastore: Object.assign(Object.assign({}, template === null || template === void 0 ? void 0 : template.datastore), datastore),
    };
};
const setDataStoreInPathPageTypeData = (template = utility_1.EmptyTemplate, action) => {
    return {
        layout: Object.assign({}, template === null || template === void 0 ? void 0 : template.layout),
        datastore: Object.assign(Object.assign({}, template === null || template === void 0 ? void 0 : template.datastore), { [action.widgetId]: Object.assign(Object.assign({}, template === null || template === void 0 ? void 0 : template.datastore[action.widgetId]), action.payload) }),
    };
};
const setActionsPageTypeData = (actionMap = {}, action) => {
    return Object.assign(Object.assign({}, actionMap), action.payload.actions);
};
const setTemplatePageTypeData = (action) => {
    return Object.assign({}, action.payload.template);
};
const setWidgetRegistry = (dispatch) => {
    return (widgetRegistry) => {
        dispatch({
            payload: Object.assign({}, widgetRegistry),
            type: types_1.GlobalActionTokens.SET_WIDGET_REGISTRY,
        });
    };
};
const setDatastore = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.SET_DATASTORE,
        });
    };
};
const setDataStoreInPath = (dispatch) => {
    return (action) => {
        dispatch(Object.assign(Object.assign({}, action), { type: types_1.GlobalActionTokens.SET_DATASTORE_IN_PATH }));
    };
};
const setActions = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.SET_ACTIONS,
        });
    };
};
const setLoaderForRoute = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.SET_LOADER_IN_PATH,
        });
    };
};
const setRouteMap = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.SET_ROUTE_MAP,
        });
    };
};
const setTemplateForRoute = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.SET_TEMPLATE_ROUTE,
        });
    };
};
const appendWidgets = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.APPEND_WIDGETS,
        });
    };
};
const removeWidgets = (dispatch) => {
    return (payload) => {
        dispatch({
            payload,
            type: types_1.GlobalActionTokens.REMOVE_WIDGETS,
        });
    };
};
const GlobalReducer = (state, action) => {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (action.type) {
        case types_1.GlobalActionTokens.SET_ROUTE_MAP: {
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign({}, action.payload) });
        }
        case types_1.GlobalActionTokens.SET_TEMPLATE_ROUTE: {
            const page = state.routeMap &&
                state.routeMap[action.payload.routeId];
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.payload.routeId]: Object.assign(Object.assign({}, page), { template: setTemplatePageTypeData(action) }) }) });
        }
        case types_1.GlobalActionTokens.SET_DATASTORE: {
            const _template = (state.routeMap &&
                state.routeMap[action.payload.routeId]
                    .template) ||
                utility_1.EmptyTemplate;
            if (_template.layout.widgets.length == 0)
                return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.payload.routeId]: setDataStorePageTypeData(_template, action.payload.datastore) }) });
        }
        case types_1.GlobalActionTokens.SET_DATASTORE_IN_PATH: {
            const _template = (state.routeMap &&
                state.routeMap[action.routeId].template) ||
                utility_1.EmptyTemplate;
            if (_template.layout.widgets.length == 0)
                return Object.assign({}, state);
            const isEqualProps = (0, utility_1.areEqualObjs)(_template.datastore[action.widgetId], action.payload);
            if (isEqualProps) {
                return state;
            }
            else {
                // console.info(
                // 	`*** update datastore ***
                // 	\nrouteId->${action.routeId}
                // 	\nwidgetId->${action.widgetId}
                // 	\nnextProps->`,
                // 	action.payload,
                // 	`\nprevProps->`,
                // 	_template.datastore[action.widgetId] as `{}`,
                // );
                return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.routeId]: Object.assign(Object.assign({}, (state.routeMap &&
                            state.routeMap[action.routeId])), { template: setDataStoreInPathPageTypeData(_template, action) }) }) });
            }
        }
        case types_1.GlobalActionTokens.SET_LOADER_IN_PATH: {
            const _widgetItemsShimmer = (state.routeMap &&
                state.routeMap[action.routeId].loading) ||
                [];
            if (_widgetItemsShimmer.length == 0)
                return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.routeId]: Object.assign(Object.assign({}, (state.routeMap &&
                        state.routeMap[action.routeId])), { loading: [...action.widgetItems] }) }) });
        }
        case types_1.GlobalActionTokens.SET_ACTIONS: {
            const oldAction = (state.routeMap &&
                action.payload.routeId &&
                state.routeMap[action.payload.routeId]
                    .actions) ||
                {};
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.payload.routeId]: Object.assign(Object.assign({}, (state.routeMap &&
                        state.routeMap[action.payload.routeId])), { actions: setActionsPageTypeData(oldAction, action) }) }) });
        }
        case types_1.GlobalActionTokens.APPEND_WIDGETS: {
            if (!state.routeMap)
                return;
            let layoutUpdatedWidgetItems = [];
            const routeId = lodash_1.default.get(action, 'payload.routeId', '');
            const datastore = lodash_1.default.get(state.routeMap, `${routeId}.template.datastore`, {});
            const layoutWidgetItems = (state.routeMap &&
                ((_a = state.routeMap[routeId].template) === null || _a === void 0 ? void 0 : _a.layout.widgets));
            if (lodash_1.default.get(action, 'payload.appendAfterWidgetId', false)) {
                /*** custom append widget logic if we want to insert new widget next after given widgetId  ***/
                layoutWidgetItems.forEach((item) => {
                    layoutUpdatedWidgetItems.push(item);
                    if (item.id ===
                        action.payload.appendAfterWidgetId) {
                        layoutUpdatedWidgetItems.push(...action.payload.widgets);
                    }
                    else if (item.type === 'STACK') {
                        /*** Handle nested widget case */
                        appendNestedWidget(action, item, datastore);
                    }
                });
            }
            else {
                /*** Normal append widget logic ***/
                layoutUpdatedWidgetItems = [
                    ...layoutWidgetItems,
                    ...action.payload.widgets,
                ];
            }
            const combined_template = {
                datastore: Object.assign(Object.assign({}, datastore), action.payload.datastore),
                layout: {
                    id: (_b = state.routeMap[action.payload.routeId]
                        .template) === null || _b === void 0 ? void 0 : _b.layout.id,
                    type: (_c = state.routeMap[action.payload.routeId]
                        .template) === null || _c === void 0 ? void 0 : _c.layout.type,
                    widgets: [...layoutUpdatedWidgetItems],
                },
            };
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.payload.routeId]: Object.assign(Object.assign({}, (state.routeMap &&
                        state.routeMap[action.payload.routeId])), { template: combined_template }) }) });
        }
        case types_1.GlobalActionTokens.REMOVE_WIDGETS: {
            if (!state.routeMap)
                return;
            const newLayouts = [];
            const existingDS = Object.assign({}, (_d = state.routeMap[action.payload.routeId]
                .template) === null || _d === void 0 ? void 0 : _d.datastore);
            const existingLayouts = (_e = state.routeMap[action.payload.routeId]
                .template) === null || _e === void 0 ? void 0 : _e.layout.widgets;
            if (existingLayouts &&
                existingLayouts.length > 0) {
                for (let i = 0; i < existingLayouts.length; i++) {
                    try {
                        if (!JSON.stringify(action.payload.widgets).includes(existingLayouts[i].id)) {
                            newLayouts.push(existingLayouts[i]);
                        }
                        else {
                            delete existingDS[existingLayouts[i].id];
                        }
                    }
                    catch (e) {
                        console.warn('error in remove widget', e);
                    }
                }
            }
            const combined_template = {
                datastore: Object.assign({}, existingDS),
                layout: {
                    id: (_f = state.routeMap[action.payload.routeId]
                        .template) === null || _f === void 0 ? void 0 : _f.layout.id,
                    type: (_g = state.routeMap[action.payload.routeId]
                        .template) === null || _g === void 0 ? void 0 : _g.layout.type,
                    widgets: [...newLayouts],
                },
            };
            return Object.assign(Object.assign({}, state), { routeMap: Object.assign(Object.assign({}, state.routeMap), { [action.payload.routeId]: Object.assign(Object.assign({}, (state.routeMap &&
                        state.routeMap[action.payload.routeId])), { template: combined_template }) }) });
        }
        default:
            return state;
    }
};
const appendNestedWidget = (action, item, datastore) => {
    let isMatchedFlag = false;
    const stackUpdatedWidgetItems = [];
    /*** check for props from datastore **/
    /*** check if the widget has widgetItems prop in datastore **/
    const datastoreWidgetItems = lodash_1.default.get(datastore, `${item.id}.widgetItems`, []);
    /*** check if widgetId is present in widgetItems of individual widget **/
    datastoreWidgetItems.forEach((item) => {
        if (item.id === action.payload.appendAfterWidgetId) {
            isMatchedFlag = true;
            /** if matched then push all new widgetItems **/
            stackUpdatedWidgetItems.push(...action.payload.widgets);
        }
        else {
            /** if no match found then keep adding existing items **/
            stackUpdatedWidgetItems.push(item);
        }
    });
    /*** update in Datastore iff widgetId === appendAfterWidgetId **/
    if (isMatchedFlag) {
        /*** update widgetItems for individual widget in datastore **/
        lodash_1.default.set(datastore, `${item.id}.widgetItems`, stackUpdatedWidgetItems);
    }
};
_a = (0, createDataContext_1.default)(GlobalReducer, {
    setWidgetRegistry,
    setDatastore,
    setDataStoreInPath,
    setActions,
    setRouteMap,
    setTemplateForRoute,
    appendWidgets,
    removeWidgets,
    setLoaderForRoute,
}, initialState), exports.Context = _a.Context, exports.Provider = _a.Provider;
//# sourceMappingURL=GlobalContext.js.map